import { useMutation } from 'react-query';
import {
  createSophiaIntegrationAsync,
  deleteSophiaIntegrationAsync,
  getAllSophiaIntegrationsAsync,
  getSophiaIntegrationByIdAsync,
  updateSophiaIntegrationAsync,
} from '../../index';

export const useCreateSophiaIntegrationAsync = () =>
  useMutation(createSophiaIntegrationAsync);

export const useGetSophiaIntegrationByIdAsync = () =>
  useMutation(getSophiaIntegrationByIdAsync);

export const useGetAllSophiaIntegrationsAsync = () =>
  useMutation(getAllSophiaIntegrationsAsync);

export const useUpdateSophiaIntegrationAsync = () =>
  useMutation(updateSophiaIntegrationAsync);

export const useDeleteSophiaIntegrationAsync = () =>
  useMutation(deleteSophiaIntegrationAsync);
